module.exports = __webpack_public_path__ + "static/media/job_status.b7cdb29f.svg";